/* eslint-disable no-undef */
import { useRouter } from 'next/router';
import { trackGaEvent } from '../services/analytics';
import { Property } from '../types';
import { getGalleryImages } from '../utils/property';
import getPropertyFloorPlan from '../utils/property/getPropertyFloorPlan';
import getPropertyTour from '../utils/property/getPropertyTour';
import getPropertyVideos from '../utils/property/getPropertyVideos';

type UseSlideshowBar = ({
  property,
  getReplaceUrl,
}: {
  property: Property;
  getReplaceUrl: (url: string) => string;
  location: string;
}) => {
  propertyVideo: ReturnType<typeof getPropertyVideos>;
  propertyTour: ReturnType<typeof getPropertyTour>;
  images: ReturnType<typeof getGalleryImages>;
  propertyFloorPlans: ReturnType<typeof getPropertyFloorPlan>;
  trackLink: (button: string) => () => void;
  handleTourClick: () => void;
  tourPath: string;
  videoPath: string;
};

const useSlideshowBar: UseSlideshowBar = (props) => {
  const propertyVideo = getPropertyVideos(props.property);
  const propertyTour = getPropertyTour(props.property);
  const images = getGalleryImages(props.property, 'hd', false, false, false, true);
  const propertyFloorPlans = getPropertyFloorPlan(props.property, 'hd');
  const router = useRouter();
  const tourPath = propertyTour?.tourIndex !== undefined ? `tour${propertyTour.tourIndex + 1}` : '';
  const videoPath = propertyVideo?.tourIndex !== undefined ? `tour${propertyVideo.tourIndex + 1}` : 'video';

  const trackLink = (button: string) => () => {
    const page = props.property.type === 'property' ? 'PDP' : 'DDP';
    trackGaEvent('media_box_click', {
      button,
      page,
      location: props.location,
    });
  };

  const handleTourClick = () => {
    trackLink('Tour')();

    if (propertyTour?.insecure) {
      window.open(propertyTour.url, '_blank', 'noopener,noreferrer');
    } else {
      // if shallow on property type slideshow bar, the slideshow bar will not update
      // to show the tour button as active, so we need to set shallow to false for this case
      router.replace(props.getReplaceUrl(`/${tourPath}`), undefined, { shallow: !props.property.virtualTour });
    }
  };

  return {
    propertyVideo,
    propertyTour,
    images,
    propertyFloorPlans,
    trackLink,
    handleTourClick,
    tourPath,
    videoPath,
  };
};

export default useSlideshowBar;
